import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getGoogleSheet,
  getMyPrediction,
  getOrdersList,
  getOrdersUpdate,
  getSymbolList,
} from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import { useNavigate } from "react-router-dom";
import SectorPanchang from "../component/sectorPanchag";
import StockStrength from "../component/stockStrength";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CreatableSelect from "react-select/creatable";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const OrdersListPage = () => {
  const [loader, setLoader] = useState(false);
  const [getOrdersListData, setOrderListData] = useState([]);
  const [symbolData, setSymbolData] = useState([]);
  const [getAllSymbolName, setAllSymbolName] = useState([]);
  const [todayData, setTodayData] = useState([]);
  const NSE_Past_date = useSelector((state) => state.pastDate.value);
  const [startDate, setStartDate] = useState(NSE_Past_date[0]?.max_date);
  // const [startDate, setStartDate] = useState(new Date());
  const [predictionData, setPredictionData] = useState([]);
  const userToken = useSelector((state) => state.userToken.value);
  const navigate = useNavigate();
  const [getSelectedDate, setSelectedDate] = useState(new Date());
  const [show, setShow] = useState(false);
  const [getSlectSymbol, setSlectSymbol] = useState(false);
  const [getSymbolLTP, setSymbolLTP] = useState(null);
  const [getItemID, setItemID] = useState(null);
  const [getSymbolDetails, setSymbolDetails] = useState();
  const [getSymbolPredication, setSymbolPredication] = useState();
  const [getModalTitle, setModalTitle] = useState("");
  const [getModalBtn, setModalBtn] = useState("");
  const [getDefaultSymbol, setDefaultSymbol] = useState(null);
  const [getAwardingName, setAwardingName] = useState();
  const [getValueOrder, setValueOrder] = useState();
  const [getPeriod, setPeriod] = useState();
  const [getStrength, setStrength] = useState();
  const [series, setSeries] = useState('EQ');

  useEffect(() => {
    if (userToken) {
      let current_date = moment(startDate).format("DDMMYY");
      getOrdersList(userToken)
        .then(function (response) {
          setLoader(true);
          setOrderListData(response.data.data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });

      getSymbolList(series, '', userToken)
        .then(function (response) {
          setSymbolData(response.data.data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });

      getMyPrediction(current_date, userToken)
        .then(function (response) {
          setPredictionData(response.data.data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });

      getGoogleSheet("", userToken)
        .then(function (response) {
          setTodayData(response.data.data.json_data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });
    } else {
      navigate(`/`);
    }
  }, [startDate]);

  useEffect(() => {
    const data = symbolData.map((i) => {
      const s = i?.symbol ?? "";
      return s ? { value: s, label: s } : null;
    });
    setAllSymbolName(data);
  }, [symbolData]);

  const showModalHandler = (e) => {
    setSymbolLTP(null);
    setSymbolDetails();
    setSymbolPredication();
    setSelectedDate(new Date());
    setModalTitle("Add New Order");
    setModalBtn("ADD");
    setItemID(null);
    setDefaultSymbol(null);
    setAwardingName(null);
    setValueOrder(null);
    setPeriod(null);
    setStrength(null);
    setShow(true);
  };

  const handleSymbolChange = (e) => {
    if (e.value) {
      setSlectSymbol(e.value);
      const todayLTP = todayData?.find((item) => item.TICKER === e.value);
      const details = symbolData?.find((item) => item.symbol === e.value);
      const prediction = predictionData?.find(
        (item) => item.symbol === e.value
      );
      setSymbolLTP(todayLTP);
      setSymbolDetails(details);
      setSymbolPredication(prediction);

      setTimeout(() => {
        let element = document.querySelector(
          "#getSymbolStrength .strength_count div"
        );
        // document.querySelector('#strength').value = element.innerText;
        setStrength(element.innerText);
      }, 200);
    }
  };

  const postOrdersData = (e) => {
    e.preventDefault();
    const form = e.target;
    const rawDate = form.elements.orderDate.value;
    const getDate = moment(rawDate, "DD/MM/YYYY HH:mm", true);

    const orderDate = moment(getDate).format("YYYY-MM-DD HH:mm:ss");
    const symbolName = form.elements.symbolName.value;
    const awardingName = form.elements.awardingName.value;
    const valueOrder = parseFloat(form.elements.valueOrder.value);
    const ordersper = parseFloat(
      ((valueOrder / getSymbolLTP?.MARKETCAP) * 100).toFixed(2)
    );
    const period = form.elements.period.value;
    const ltp = form.elements.ltp.value;
    const strength = form.elements.strength.value;
    const turnOver = Math.round(
      (getSymbolLTP?.LTP * getSymbolLTP?.VOLUME) / 10000000
    );
    const marketcap = Math.round(getSymbolLTP?.MARKETCAP / 10000000);
    const turnOverPer = parseFloat(((turnOver / marketcap) * 100).toFixed(2));

    const payload = {
      method: getModalBtn === "ADD" ? "new" : "update",
      symbol: symbolName,
      datetime: orderDate,
      awarding: awardingName,
      valueOrder: valueOrder,
      period: period,
      close_price: ltp,
      strength: strength,
      marketcap: marketcap,
      turnOverPer: turnOverPer,
      ordersper: ordersper,
      ...(getModalBtn === "UPDATE" ? { id: getItemID } : ""),
    };

    if (
      symbolName === "" ||
      awardingName === "" ||
      valueOrder === "" ||
      period === "" ||
      ltp === "" ||
      strength === ""
    ) {
      toast.error("Please fill the required field");
      return false;
    }

    getOrdersUpdate(payload, userToken)
      .then(function (response) {
        if (response.data.status === true) {
          toast.success(response.data.message);
          getOrdersList(userToken)
            .then(function (response) {
              setOrderListData(response.data.data);
              setShow(false);
            })
            .catch(function (err) {
              console.log("Error", err);
            });
        } else {
          toast.error(response.data.message);
        }
      })
      .catch(function (err) {
        console.log("Error", err);
      });
  };

  const updateOrders = (e, item) => {
    let symbolName = item.symbol;
    const rawDate = item.datetime;
    const m = moment(rawDate, "DD/MM/YYYY HH:mm", true);
    if (m.isValid()) {
      const dateObj = m.toDate();
      setSelectedDate(dateObj);
    }

    setModalTitle("Update Order");
    setModalBtn("UPDATE");
    setItemID(item.id);
    setDefaultSymbol({ value: symbolName, label: symbolName });
    setAwardingName(item.awarding);
    setValueOrder(parseInt(item.valueOrder) !== 0 ? item.valueOrder : null);
    setPeriod(item.period !== "" ? item.period : null);
    // setStrength(item.strength !==""? item.strength: null);

    setTimeout(() => {
      let element = document.querySelector(
        "#getSymbolStrength .strength_count div"
      );
      // document.querySelector('#strength').value = element.innerText;
      if (element) {
        setStrength(element.innerText);
      }
    }, 200);

    setSlectSymbol(symbolName);
    const todayLTP = todayData?.find((item) => item.TICKER === symbolName);
    const details = symbolData?.find((item) => item.symbol === symbolName);
    const prediction = predictionData?.find(
      (item) => item.symbol === symbolName
    );
    setSymbolLTP(todayLTP);
    setSymbolDetails(details);
    setSymbolPredication(prediction);
    setShow(true);
  };

  const removeOrders = (e, id) => {
    e.preventDefault();
    const payload = {
      method: "delete",
      id: id,
    };
    getOrdersUpdate(payload, userToken)
      .then(function (response) {
        if (response.data.status === true) {
          toast.success(response.data.message);
          const element = document.getElementById("item_row_id_" + id);
          if (element) {
            element.remove();
          }
        } else {
          toast.error(response.data.message);
        }
      })
      .catch(function (err) {
        console.log("Error", err);
      });
  };

  return (
    <React.Fragment>
      <div className="pageContainer">
        {loader === false ? (
          <PageLoader />
        ) : (
          <div className="pagewrap fullheight">
            <table className="increaseOI table-responsive">
              <thead>
                <tr key="item_0_0">
                  <th style={{ width: "110px" }}>
                    <a
                      target="_blank"
                      href="https://www.nseindia.com/companies-listing/corporate-filings-announcements-xbrl"
                    >
                      Date
                    </a>
                  </th>
                  <th style={{ width: "140px" }}>
                    Symbol{" "}
                    <button
                      className="btn btn-sm py-0 btn-primary float-end"
                      type="button"
                      onClick={(e) => showModalHandler(e)}
                    >
                      New Order
                    </button>
                  </th>
                  <th style={{ width: "15px" }}></th>
                  <th style={{ width: "40px" }}></th>
                  <th style={{ width: "40px", textAlign: "left" }}>Strength</th>
                  <th style={{ textAlign: "left", width: "120px" }}>Sector</th>
                  <th style={{ textAlign: "left", width: "180px" }}>
                    Awarding
                  </th>
                  <th style={{ width: "50px", textAlign: "left" }}>Indices</th>
                  <th style={{ width: "60px" }}>Value(CR)</th>
                  <th style={{ width: "50px" }}>Value%</th>
                  <th style={{ width: "50px" }}>Period</th>
                  <th style={{ width: "50px" }}>Price</th>
                  <th style={{ width: "50px" }}>LTP</th>
                  <th style={{ width: "50px" }}>Chn%</th>
                  <th style={{ width: "50px" }}>Tchn%</th>
                  <th style={{ width: "50px" }}>14 P/L</th>
                  {/* <th style={{width:'150px'}}>14 | 9 | 5 Deg&deg;</th> */}
                  <th style={{ width: "50px" }}>SMA200</th>
                  <th style={{ width: "60px" }}>
                    52 Down{" "}
                    {/* <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('down_now')}}></button> */}
                  </th>
                  <th>52 L/H</th>
                  <th style={{ width: "75px" }}>AT Vol</th>
                  <th style={{ width: "50px" }}>Del %</th>
                  <th style={{ width: "60px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {getOrdersListData?.map((item, index) => {
                  // console.log(item)
                  const symbolName = item.symbol;
                  const details = symbolData?.find(
                    (item, index) => item.symbol === symbolName
                  );
                  const todayLTP = todayData?.find(
                    (item, index) => item.TICKER === symbolName
                  );
                  const prediction = predictionData?.find(
                    (item, index) => item.symbol === symbolName
                  );
                  return (
                    <tr
                      className={`tr_${item.id}`}
                      key={`item_row_id_${item.id}`}
                      id={`item_row_id_${item.id}`}
                    >
                      <td>
                        {moment(item.datetime).format("DD/MM/YYYY HH:mm")}
                      </td>
                      <td id={`item_id_${item.id}`} className="symbolName">
                        <a
                          href={`https://www.google.com/search?q=why+${symbolName}+share+more+volume+on+${moment(
                            item.datetime
                          ).format("Do MMMM YYYY")}`}
                          target="_blank"
                          style={{ display: "block" }}
                        >
                          {symbolName}
                        </a>
                        {details?.hotStar === "1" ? (
                          <span className="hotStar"></span>
                        ) : null}
                      </td>
                      <td>
                        <StockAction
                          symbol={symbolName}
                          delivery={false}
                          currentPrice={todayLTP?.LTP}
                          deliveryPer={prediction?.delivery_per}
                          hotStar={details?.hotStar}
                          myFev={details?.myFev}
                          eventName="Orders"
                          rowId={`item_row_id_${item.id}`}
                        />
                      </td>
                      <td>
                        <DeliveryGraph
                          symbol={symbolName}
                          todayLTP={todayLTP}
                          date={moment(NSE_Past_date[0]?.max_date).format(
                            "YYYY-MM-DD"
                          )}
                        />
                      </td>
                      <StockStrength
                        id={`w_${item.id}`}
                        selectedDate={startDate}
                        symbol={symbolName}
                        todayLTP={todayLTP}
                        details={details}
                        predictions={prediction}
                      />
                      <SectorPanchang
                        symbol={symbolName}
                        sector={details?.group_sector}
                        todayData={todayData}
                        symbolData={symbolData}
                        tag = "td"
                        align = "right"
                        durationDays = ""
                      />

                      <td style={{ textAlign: "left", lineHeight: "1.2" }}>
                        {item.awarding}
                      </td>
                      <td className="indices" style={{ textAlign: "left" }}>
                        {(() => {
                          const label = details?.nifty50
                            ? "50"
                            : details?.nifty100
                            ? "100"
                            : details?.nifty200
                            ? "200"
                            : details?.nifty500
                            ? "500"
                            : details?.totalMarket
                            ? "TM"
                            : "";
                          const excludedSeries = ["ETF", "BOND", "MF"];
                          const showFev =
                            details?.myFev &&
                            !excludedSeries.includes(details?.series);
                          return (
                            label + (showFev ? `${label ? ", " : ""}Fev` : "")
                          );
                        })()}
                      </td>
                      <td>{parseFloat(item.valueOrder) / 10000000}</td>
                      <td>{item.ordersper}%</td>
                      <td style={{ textAlign: "left", lineHeight: "1.2" }}>
                        {item.period}
                      </td>
                      <td>{item.close_price}</td>
                      <td>{todayLTP?.LTP}</td>
                      <td>{todayLTP?.CHANGEPER}%</td>
                      <td>
                        {(
                          ((todayLTP?.LTP - item.close_price) * 100) /
                          item.close_price
                        ).toFixed(2)}
                        %
                      </td>
                      <td
                        title={`${prediction?.price_14} | ${moment(
                          prediction?.price_14_date
                        ).format("DD/MM/YYYY")}`}
                      >
                        {prediction?.price_14_date_PL}%
                      </td>
                      <td
                        style={{
                          textAlign: "right",
                          background:
                            prediction?.sma50 > prediction?.sma200
                              ? "#e2ffe5"
                              : "#fff8f8",
                        }}
                        title={`DMA50: ${prediction?.sma50}`}
                      >
                        {prediction?.sma200}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {details?.high52w
                          ? (
                              ((details?.high52w - todayLTP?.LTP) * 100) /
                              details?.high52w
                            ).toFixed(2)
                          : ""}
                        %
                      </td>
                      <td
                        title={`${moment(details?.lowDate).format(
                          "DD-MM-YY"
                        )} / ${moment(details?.highDate).format("DD-MM-YY")}`}
                      >
                        {details?.low52w}
                        {details ? "/" : ""}
                        {details?.high52w}
                      </td>
                      <td>{todayLTP?.VOLUME.toLocaleString("en-IN")}</td>
                      <td>{prediction?.delivery_per}%</td>
                      <td>
                        <button
                          type="button"
                          className="addPortfolio"
                          onClick={(e) => updateOrders(e, item)}
                        ></button>
                        <button
                          type="button"
                          className="removelist"
                          onClick={(e) => removeOrders(e, item.id)}
                        ></button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        // fullscreen = {true}
        dialogClassName="watchlist-details"
        // backdrop="static"
        // keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <h5 className="p-3 mb-0 pb-0">{getModalTitle}</h5>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => postOrdersData(e)} className="p-3">
            <div className="row">
              <div className="col" style={{ width: "180px" }}>
                <div className="form-floating">
                  <DatePicker
                    showTimeSelect // enable time selection
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="dd/MM/yyyy HH:mm"
                    placeholderText="Select date & time"
                    calendarClassName="withtime"
                    className="form-control"
                    selected={getSelectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    minDate={moment().subtract(5, "days")}
                    maxDate={new Date()}
                    name="orderDate"
                    // filterDate={isWeekdayAllowed}
                  />
                  <label className="show" htmlFor="orderDate">
                    Order Date
                  </label>
                </div>
              </div>

              <div
                className="col ps-0"
                style={{ width: "200px", "max-width": "200px" }}
              >
                <div className="form-floating" style={{ "z-index": "999" }}>
                  <CreatableSelect
                    name="symbolName"
                    onChange={(e) => handleSymbolChange(e)}
                    defaultValue={getDefaultSymbol}
                    isClearable={false}
                    options={getAllSymbolName}
                  />
                  <label className="show" htmlFor="symbolName">
                    Symbol
                  </label>
                </div>
              </div>

              <div className="col ps-0">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="awardingName"
                    defaultValue={getAwardingName}
                    placeholder="Awarding From"
                  />
                  <label htmlFor="awardingName">Awarding From</label>
                </div>
              </div>

              <div
                className="col ps-0"
                style={{ width: "160px", "max-width": "160px" }}
              >
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="valueOrder"
                    defaultValue={getValueOrder}
                    placeholder="Value of the order"
                  />
                  <label htmlFor="valueOrder">Value of the order</label>
                </div>
              </div>

              <div
                className="col ps-0"
                style={{ width: "130px", "max-width": "130px" }}
              >
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="period"
                    defaultValue={getPeriod}
                    placeholder="Time period"
                  />
                  <label htmlFor="period">Time period</label>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div
                className="col"
                style={{ width: "180px", "max-width": "180px" }}
              >
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="ltp"
                    id="ltp"
                    placeholder="LTP"
                    defaultValue={getSymbolLTP?.LTP}
                  />
                  <label htmlFor="ltp">LTP</label>
                </div>
              </div>
              <div
                className="col ps-0"
                style={{ width: "200px", "max-width": "200px" }}
              >
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="strength"
                    defaultValue={getStrength}
                    placeholder="Strength"
                  />
                  <label htmlFor="strength">Strength</label>
                </div>
              </div>

              {getSlectSymbol &&
              getSymbolLTP &&
              getSymbolDetails &&
              getSymbolPredication ? (
                <>
                  <div className="col-auto pt-2 ps-0" id="getSymbolStrength">
                    <table>
                      <tr>
                        <StockStrength
                          id="symbolStrength"
                          selectedDate={moment(startDate).format("YYYY-MM-DD")}
                          symbol={getSlectSymbol}
                          todayLTP={getSymbolLTP}
                          details={getSymbolDetails}
                          predictions={getSymbolPredication}
                        />
                      </tr>
                    </table>
                  </div>
                  <div className="col-auto pt-1">
                    <DeliveryGraph
                      symbol={getSlectSymbol}
                      todayLTP={getSymbolLTP}
                      date={moment(startDate).format("YYYY-MM-DD")}
                    />
                  </div>

                  <div className="col-auto pt-1">
                    <div className="form-floating">
                      <span
                        className="pt-1 d-inline-block"
                        style={{ "margin-left": "11px" }}
                      >
                        {Math.round(getSymbolLTP?.MARKETCAP / 10000000)}
                      </span>
                      <label className="show" htmlFor="strength">
                        MARKETCAP
                      </label>
                    </div>
                  </div>

                  <div className="col-auto pt-1 ps-5">
                    <div className="form-floating">
                      <span
                        className="pt-1 d-inline-block"
                        style={{ "margin-left": "12px" }}
                      >
                        {parseFloat(
                          (
                            (getValueOrder / getSymbolLTP?.MARKETCAP) *
                            100
                          ).toFixed(2)
                        )}
                      </span>
                      <label className="show" htmlFor="strength">
                        Order%
                      </label>
                    </div>
                  </div>
                </>
              ) : null}

              <div className="col ps-0 text-end">
                <button
                  type="submit"
                  name="btnAction"
                  className="btn btn-primary px-5"
                >
                  {getModalBtn}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
export default OrdersListPage;
